import { ReactNode, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import PrintPage from "@components/print/PrintElements/PrintPage";
import PrintPageHeader from "@components/print/PrintElements/PrintPageHeader";
import PrintPageFooter from "@components/print/PrintElements/PrintPageFooter";
import { useAppSelector } from "@/store/hooks";
import PrintDocumentHeader from "@components/print/PrintElements/PrintDocumentHeader";
import ProductList from "@components/print/PrintElements/ProductList";
import { ProviderOrderApi, ProviderOrderDataType } from "@/api/ProviderOrderApi";
import { EDocumentProductDataType } from "@/formTypes/EDocumentProductDataType";
import { formatDate } from "@utils/Api";

import { chunkArray } from "@utils/Utils";
import { sortProductsByOrder } from "@utils/EDocument";
import { PrintPageDataLoadedPubSub } from "@utils/pubsubs/PubSub";
import { CurrencyApi, CurrencyDataType } from "@/api/CurrencyApi";
import ProviderOrderDocumentInfo from "@components/print/PrintElements/ProviderOrderDocumentInfo";

const ProviderOrderPrint = () => {
  const params = useParams()
  const { id: providerOrderId, autoPrint = false, copies = 0 } = params;

  const suscription = useAppSelector((state) => { return state.suscription.suscription });
  const maxItemPerPage = Number(suscription?.items_per_page || 30)
  const [currency, setCurrency] = useState<CurrencyDataType>({})
  const [providerOrder, setProviderOrder] = useState<ProviderOrderDataType>({})
  const [providerOrderProdCount, setProviderOrderProdCount] = useState<number>(0)
  const [providerOrdersProducts, setProviderOrdersProducts] = useState<EDocumentProductDataType[]>()
  const [documentPages, setDocumentPages] = useState<EDocumentProductDataType[][]>()

  useEffect(() => {
    import("@printerVariation/generic.scss");
    PrintPageDataLoadedPubSub.publish({ dataLoaded: false })
    loadProviderOrderData()
  }, []);

  useEffect(() => {
    const pages = chunkArray(providerOrdersProducts || [], maxItemPerPage)
    setDocumentPages(pages)
  }, [maxItemPerPage, providerOrdersProducts]);

  const loadProviderOrderData = async () => {
    if (providerOrderId) {
      const providerOrder = await ProviderOrderApi.get(providerOrderId)
      const currency = await CurrencyApi.get(`${providerOrder.currencyId}`)
      setCurrency(currency)

      let products: EDocumentProductDataType[];
      try {
        products = JSON.parse(`${providerOrder.products}`)
      } catch (err) {
        console.log("unable to load the previous order products")
        products = [];
      }

      setProviderOrdersProducts(sortProductsByOrder(products))
      setProviderOrderProdCount(products?.length || 0)
      setProviderOrder(providerOrder)
    }
    PrintPageDataLoadedPubSub.publish({ dataLoaded: true })
  }

  const renderPage = (documentPages: EDocumentProductDataType[][]): ReactNode[] => {
    return documentPages.map((page, index) => {
      return (
        <PrintPage
          autoPrint={autoPrint === "1"}
          copies={Number(copies)}
        >
          <PrintPageHeader suscription={suscription} />
          <div className="page-content">
            <PrintDocumentHeader title={`Orden de compra #${providerOrder.numero}`} fecha={formatDate(providerOrder.fecha, "YYYY-MM-DD", "DD.MM.YY")} />
            <ProviderOrderDocumentInfo
              providerOrder={providerOrder}
            />
            <ProductList
              maxItemPerPage={maxItemPerPage}
              products={page}
              productCount={providerOrderProdCount}
              productTableClassName={styles.productTable}
            />
            <PrintPageFooter
              currencyCode={Number(currency.currency_id || 1)}
              exchangeRate={providerOrder.exchange_rate || 0}
              comments={[
                `${providerOrder.comments}`
              ]}
              summaryText="Por favor suministrar lo bienes y/o servicios detallados Unicamente a la persona designada en el inicio de este documento"
              currentPage={(index + 1)}
              hideBankAccount={true}
              hideATVDisclaimer={true}
              totalPages={documentPages.length} />
          </div>

        </PrintPage>
      )
    });
  }

  return (
    <div>
      {providerOrder?.id && documentPages && renderPage(documentPages)}
      {!providerOrder.id && (
        <h3>Cargando</h3>
      )}

    </div>
  );
}

export default ProviderOrderPrint;
